import React from 'react';
import Link from '@material-ui/core/Link';
import Typography from '@material-ui/core/Typography';

import Logo from '../../../Assets/--WhiteBluePNG-TM.png';

export default ({ secondary }) => (
  <footer className={`auth_footer${secondary ? ' secondary' : ''}`}>
    <div className="first_line">
      <span>© 2019-2020</span>
      <img src={Logo} alt="logo" style={{ width: '110px', height: '38px' }} />
      <span>, LLC.</span>
      <span>All Rights Reserved.</span>
      <p className="links">
      <span className="separator">|</span><Link href="https://8f8eede4-3731-4555-93ea-e9c60516663b.filesusr.com/ugd/5ccf7f_cabcc8e5abe44bd5ba0a0c139e02a052.pdf" target="_blank">Privacy Policy</Link>
      <span className="separator">|</span><Link href="https://8f8eede4-3731-4555-93ea-e9c60516663b.filesusr.com/ugd/5ccf7f_b06e5252f1df449c90fbab596d492685.pdf" target="_blank">Terms of Service</Link>
      <span className="separator">|</span><Link href="https://www.focusloop.io/">Meet the Team</Link>
      <span className="separator">|</span><Link href="https://focusloop.io/contact">Contact</Link>
      </p>
    </div>
    {!secondary && (
      <div className="second_line">
      Focusloop is currently available only to companies based in the US<img src="/images/us-flag.webp" alt="flg" />
      </div>
    )}
  </footer>
)
